import type { SVGProps } from 'react';

const Delegate = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8333 8C12.8333 10.6694 10.6694 12.8333 8 12.8333C5.33062 12.8333 3.16667 10.6694 3.16667 8C3.16667 5.33062 5.33062 3.16667 8 3.16667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.66667 5.83333H7.75C7.15167 5.83333 6.66667 6.31836 6.66667 6.91667C6.66667 7.515 7.15167 8 7.75 8H8.58333C9.18167 8 9.66667 8.485 9.66667 9.08333C9.66667 9.68167 9.18167 10.1667 8.58333 10.1667H6.66667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.16667 5.16667V5.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.16667 10.5V10.8333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 4.33333L12 3L10.6667 4.33333M12 3L12 5.66667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Delegate;
